import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Snackbar, Alert } from '@mui/material';
import { logout, clearAllState, tokenRefreshed } from '../redux/slices/authSlice';

const TokenExpirationHandler = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleTokenExpired = (event) => {
      setMessage(event.detail?.message || 'Session expired. Please log in again.');
      setOpen(true);

      // Clear Redux state. Redirect is handled by the API layer when the session
      // is definitively gone; keep a short fallback in case that path was skipped.
      dispatch(logout());
      dispatch(clearAllState());

      if (!window.location.pathname.startsWith('/login')) {
        setTimeout(() => {
          window.location.href = '/login';
        }, 100);
      }
    };

    const handleTokenRefreshed = (event) => {
      const nextToken = event.detail?.token;
      if (nextToken) {
        dispatch(tokenRefreshed({ token: nextToken }));
      }
    };

    // Listen for token expiration events
    window.addEventListener('tokenExpired', handleTokenExpired);
    window.addEventListener('authTokenRefreshed', handleTokenRefreshed);

    return () => {
      window.removeEventListener('tokenExpired', handleTokenExpired);
      window.removeEventListener('authTokenRefreshed', handleTokenRefreshed);
    };
  }, [dispatch, navigate]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert 
        onClose={handleClose} 
        severity="warning" 
        variant="filled"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default TokenExpirationHandler;
